















































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";

import Auth from "@/plugins/auth";
import Endpoint from "@/utils/endpoint";
import UserInterface from "@/types/app/IUser";
import Customer from "@/types/customer/Customer";
import Account from "@/types/app/accounts";
import Company from "@/types/app/companies";
import * as Sentry from "@sentry/browser";
import AccountService from "./services/accountService";
import CompanyService from "./services/companyService";
import Product from "@/types/app/products";
import { getProducts } from "@/utils/getProducts";
import ErrorService from "./services/erroService";
import { getNotifications } from "@/utils/getNotifications";
import NotificationInterface from "./types/app/notifications";
import ModalCacheManager from "@/components/common/ModalCacheManager.vue";
import RefreshStore from "./services/refreshStore";
const namespace = "auth";
const authentication = new Auth();

@Component({
  components: { jobInfo: ModalCacheManager,},
})
export default class App extends Vue {
  drawer = true;
  @Getter("getModalMessageState", { namespace: "customer" })
  modalMessageState!: boolean;
  @Getter("getCustomer", { namespace: "customer" }) customer!: Customer;
  @Getter("getUser", { namespace }) user!: UserInterface;
  @Getter("getIslogged", { namespace }) isLogged!: boolean;
  @Action("setNotificationsState", { namespace: "customer" })
  setNotificationsState!: (notification: NotificationInterface[]) => void;
  @Action("setUser", { namespace }) setUser: any;
  @Action("setModalMessageState", { namespace: "customer" })
  setModalMessageState!: any;
  @Action("setAccountsState", { namespace: "account" })
  setAccountsState!: (account: Account[]) => void;
  @Action("setModalJobInfoState", { namespace: "customer" })
  setModalJobInfoState!: (show: boolean) => void;

  @Action("clearAllData", { namespace: "communication" })
  clearAllData!: () => void;

  @Action("setCompaniesState", { namespace: "company" })
  setCompaniesState!: (account: Company[]) => void;

  @Action("setCustomers", { namespace: "customer" }) setCustomers!: any;

  @Action("setProductsState", { namespace: "product" })
  setProductsState!: (products: Product[]) => void;

  @Getter("getLoading", { namespace: "customer" }) loading!: boolean;
  @Action("setLoading", { namespace: "customer" }) setLoading!: any;

  private endpoint = new Endpoint();
  created() {
    try {
      this.getRoute();
      if (!this.isLogged) {
        const user = authentication.getUserFromToken();

        if (user) {
          this.setUser(user);
          Sentry.setUser({ email: user.email, id: user.id });
        }
      }
    } catch (error) {
      ErrorService.onError(error);
    }
  }

  polling = 0;

  beforeDestroy() {
    clearInterval(this.polling);
  }

  border = false;

  get borderColor(): boolean {
    return this.$route.name === "Users";
  }

  getRoute(): void {
    this.$route.name === "Users" ? (this.border = true) : (this.border = false);
  }

  closeModalMessage(): void {
    this.setModalMessageState(false);
  }

  public logout(): void {
    this.border = false;
    localStorage.setItem(`store-${process.env.NODE_ENV}`, "");
    this.$router.replace({
      name: "Login",
    });
  }

  public refreshData(): void {
    // RefreshStore.$emit("refreshSelectedAll");
    localStorage.setItem(`store-${process.env.NODE_ENV}`, "");
    this.$router.replace({
      name: "Users",
    });
    this.showCacheManger();
  }

  showCacheManger() {
    this.setModalJobInfoState(true);
  }

}
